import './sign-confirmation.less'

import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {Button, Input, message} from 'antd';
import {Env} from '../../../env';

@inject('loginStore')
@observer
class SignConfirmation extends Component {
  codeInput = null;

  state = {
    resent: false
  };

  render() {
    const {isLoginInProcess, user: { user }} = this.props.loginStore;

    return (
      <React.Fragment>
        <section className="left-section">
          <h2>Добро пожаловать</h2>
          <p>
            Введите логин и пароль, чтобы получить доступ к личному кабинету. Если у вас нет личного кабинета, пройдите регистрацию.
            <p className="footer">
              Возникли вопросы ? Звоните ! {Env.phone}
            </p>
          </p>
          <Button size={'large'} onClick={::this.logout}>Выйти</Button>
        </section>
        <section className="right-section">
          <div className="right-side">
            <h1>Подтверждение телефона</h1>
            <div>На ваш номер <b>+7{user.phone}</b> отправлена смс с кодом подтверждения</div>

            <div style={{ marginTop: 12 }}>
              <Input placeholder="Введите код подтверждения" style={{ width: 240 }} size="large" ref={el => this.codeInput = el} />
              <Button type={'primary'}
                      size="large"
                      onClick={::this.submit}
                      loading={isLoginInProcess}
                      style={{ marginLeft: 6 }}
                      disabled={isLoginInProcess}>Подтвердить</Button>
            </div>
            <div style={{ marginTop: 6 }}>
              {!this.state.resent && <a onClick={::this.resend}>Отправить еще раз</a>}
              {this.state.resent && <span>Код переотправлен</span>}
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }

  logout() {
    this.props.loginStore.logout();
  }

  submit() {
    this.props.loginStore.signConfirm(this.codeInput.state.value);
  }

  async resend() {
    const res = await this.props.loginStore.signResend();
    if (res) {
      message.success('Код переотправлен на ваш телефон');
      this.setState({ resent: true});
    }
  }

}


export default SignConfirmation



// WEBPACK FOOTER //
// ./src/components/pages/auth/sign-confirmation.js